// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customFullWidthInput[data-v-843a99a0] {\n  width: 100% !important;\n}\n.fullWidth[data-v-843a99a0] {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n.customIcon[data-v-843a99a0] {\n  top: 0 !important;\n  height: 33px;\n}\n@media screen and (min-width: 500px) {\n.errorMargin[data-v-843a99a0] {\n    margin-left: 26px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
